import { render, staticRenderFns } from "./ServerBusyError.vue?vue&type=template&id=4c73d3f2&scoped=true&"
import script from "./ServerBusyError.vue?vue&type=script&lang=js&"
export * from "./ServerBusyError.vue?vue&type=script&lang=js&"
import style0 from "./ServerBusyError.vue?vue&type=style&index=0&id=4c73d3f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c73d3f2",
  null
  
)

export default component.exports